import { take, put } from 'redux-saga/effects';
import { expungeImageLink } from '../../../firebaseServices/dataServices/dataServiceActions/imageLinkActions';
import { imageLinkExpungeRequest, imageLinkExpungeStatusChange } from '../../slices/imageLink/imageLinkExpungeStatusSlice';
import { imageLinkExpungeFailureChange } from '../../slices/imageLink/imageLinkExpungeFailureSlice';
import { enumWorkflowState } from '../../../dataObjects/enums';

/**
 * @function expungeImageLinkRequestedSaga A saga workflow pertaining to a user having requested to expunge a imageLink.
 */
export function* expungeImageLinkRequestedSaga() {
  // console.info('(expungeImageLinkRequestedSaga) entered expungeImageLinkRequestedSaga');

  // loop to keep the saga running throughout the life of the application
  while (true) {
    try {
      // wait on the imageLinkExpungeRequest action to be dispatched and get the payload data...
      const imageLinkExpungeRequestData = yield take(imageLinkExpungeRequest);
      const { payload: imageLink } = imageLinkExpungeRequestData;

      // make a request to expunge the imageLink
      yield expungeImageLink(imageLink)

      // dispatch an action to indicate that the expunge operation was successful
      yield put(imageLinkExpungeStatusChange(enumWorkflowState.Success));
    } catch (error: any) {
      // dispatch an action to indicate that the expunge operation failed
      yield put(imageLinkExpungeStatusChange(enumWorkflowState.Failure));
      yield put(imageLinkExpungeFailureChange(error));
    }
  }
}
